'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { useProgressContext } from './Context';
import { progressTheme } from './theme';
const LineProgressBar = forwardRef(({ className, lineBackground }, ref) => {
    const { line } = progressTheme;
    const { lineProgressBar } = useProgressContext();
    return (_jsx("div", { ref: ref, className: cn(line.progress.base, 'h-2.5', lineBackground), children: _jsx("div", { className: cn(line.progress.bar, className), style: { width: lineProgressBar + '%' } }) }));
});
LineProgressBar.displayName = 'LineProgressBar';
export { LineProgressBar };
